// extracted by mini-css-extract-plugin
module.exports = {"page":"Freeze_page_1glMo","divider":"Freeze_divider_1Oo23","keywords":"Freeze_keywords_3I8Bx"};